var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill",
    fillRule: "evenodd",
    d: "M5.25 21h13.5c1.24 0 2.25-1 2.25-2.25V5.25C21 4.01 20 3 18.75 3H5.25C4.01 3 3 4 3 5.25v13.5C3 19.99 4 21 5.25 21ZM17.28 9.82c0 3.33-2.48 7.18-7.01 7.18a6.88 6.88 0 0 1-3.77-1.13 4.86 4.86 0 0 0 3.64-1.05 2.47 2.47 0 0 1-2.3-1.75 2.36 2.36 0 0 0 1.11-.04 2.51 2.51 0 0 1-1.97-2.48v-.03c.33.19.71.3 1.11.31a2.55 2.55 0 0 1-.76-3.37 6.94 6.94 0 0 0 5.08 2.64A2.5 2.5 0 0 1 14.8 7c.7 0 1.34.3 1.8.8a4.83 4.83 0 0 0 1.56-.61c-.19.59-.58 1.08-1.09 1.4.5-.07.98-.2 1.42-.4-.33.5-.75.95-1.23 1.3v.33Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter24);
export default __webpack_public_path__ + "static/media/twitter_24.0b7a9eda52b5d85cdcd4e6322f0d448f.svg";
export { ForwardRef as ReactComponent };